import { useTRPC } from "@/trpc/client";
import { useQuery } from "@tanstack/react-query";

/**
 * Playbook objectives for the business; the editor filters by scope (org-wide
 * vs team) client-side, mirroring the KPI definitions card. Pass
 * `includeArchived` to also show concluded objectives (evaluated experiments
 * live there).
 */
export function usePlaybookObjectives(
  businessId: string | undefined,
  includeArchived = false,
) {
  const trpc = useTRPC();
  return useQuery(
    trpc.intelligence.playbook.list.queryOptions(
      { businessId: businessId ?? "", includeArchived },
      { enabled: Boolean(businessId) },
    ),
  );
}

/**
 * Deterministic progress per linked-KPI objective (on track / stalling / off
 * track + the period series behind the sparkline). Computed server-side on
 * read - no storage.
 */
export function usePlaybookProgress(businessId: string | undefined) {
  const trpc = useTRPC();
  return useQuery(
    trpc.intelligence.playbook.progress.queryOptions(
      { businessId: businessId ?? "" },
      { enabled: Boolean(businessId) },
    ),
  );
}
